import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, mergeProps } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerDivider({
  as = DefaultElement,
  children,
  forwardedRef,
  orientation = "horizontal",
  ...rest
}) {
  const orientationValue = useResponsiveValue(orientation);

  const labelMarkup = children && /*#__PURE__*/_jsx(Text, {
    className: "o-ui-divider-label",
    children: children
  });

  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      "aria-orientation": orientationValue,
      as,
      className: cssModule("o-ui-divider", labelMarkup && "has-label"),
      ref: forwardedRef,
      role: "separator"
    }),
    children: labelMarkup
  });
}
InnerDivider.defaultElement = DefaultElement;
export const Divider = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerDivider, { ...props,
  forwardedRef: ref
}));